export default __webpack_public_path__ + "static/media/inst.f0e7a8c8.jpg";